import logo from "../../../../../assets/images/pages/login/Logo.svg";
import CloseLeft from "../../../../../assets/images/pages/login/CaretLeft.svg";
import styles from "./Register.module.scss";
import InputComponent from "../../../../shared/input/InputComponent";
import MainButton from "../../../../shared/button/MainButton";
import { useEffect, useState } from "react";
import SelectComponent from "../../../../shared/select/SelectComponent";
import PhoneInputComponent from "../../../../shared/input-phone-component/PhoneInputComponent";
import CheckBoxSelected from "../../../../shared/checkBoxSelected/CheckBoxSelected";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsLogin,
  setIsOtp,
  setIsRegister,
  setIsUserStatus,
  setOtpSession,
  setOperationType,
  setOtpType,
  setMessageType,
} from "../../../../../redux/Slices/userSlice";
import { Link } from "react-router-dom";
import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import { RootState } from "../../../../../redux/store";
import { CitiesDataType } from "../../../../../interface/site.interface";
import { CitiesService } from "../../../../../services/cities.service";
import {
  userRegisterJuristical,
  userRegisterPyhsical,
} from "../../../../../services/auth.service";
import { clearStoredRef, getStoredRef } from "../../../../../utils/utils";
import CustomCheckbox from "../../../../shared/checkBox/CheckBox";
import SmsCheckboxIcon from "../../../../../assets/images/pages/login/checkboxMessage.svg";
import TermsCheckboxIcon from "../../../../../assets/images/pages/login/checkBox.svg";
import { Flex } from "antd";
import UserTermsCheckbox from "../../../../shared/user_terms-checkbox/UserTermsCheckbox";
import { useSite } from "../../../../../context/TranslationContext";
const Register = () => {
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isShowConfrimPassword, setIsShowConfrimPassword] = useState(false);
  const userStatus = useSelector((state: RootState) => state.user.userStatus);
  const referralCode = getStoredRef();
  const [cities, setCities] = useState<CitiesDataType[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [phoneCode, setPhoneCode] = useState("50");
  const { data } = useSelector((state: RootState) => state.translationData);
  const [heardFromCustom, setHeardFromCustom] = useState("");
  const [formValues, setFormValues] = useState({
    name: "",
    surname: "",
    email: "",
    birthday: "",
    voen: "",
    firm: "",
    password: "",
    password_confirmation: "",
    city: "",
    address1: "",
    passport_series: "",
    passport_number: "",
    passport_fin: "",
    gender: "",
    heard_from: "",
    agreement: false,
    citizenship: "",
    notSendSms: false,
    language: "",
    phone_prefix: "",
    phone1: "",
    sms: false,
    mail: false,
  });
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

  const dispach = useDispatch();
  type InputChangeEvent =
    | React.ChangeEvent<HTMLInputElement>
    | { target: { name: string; value: string } };

  const handleInputChange = (e: InputChangeEvent) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    if (value.trim() === "") {
      setFormErrors((prev) => ({
        ...prev,
        [name]: "Bu xana boş ola bilməz.",
      }));
    } else {
      if (formErrors[name]) {
        setFormErrors((prev) => {
          const updatedErrors = { ...prev };
          delete updatedErrors[name];
          return updatedErrors;
        });
      }
    }
  };
  const handleSelectChange = (name: string, value: string | number) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    if (formErrors[name]) {
      setFormErrors((prev) => {
        const updatedErrors = { ...prev };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const LoginClose = () => {
    dispach(setIsRegister(false));
    dispach(setIsUserStatus(true));
  };
  const RegisterClose = () => {
    dispach(setIsRegister(false));
    dispach(setIsLogin(false));
  };
  useEffect(() => {
    CitiesService.getAllCities().then((response) => {
      if (response.status === 200) {
        setCities(response?.data?.original);
      }
    });
  }, []);
  const handleCodeChange = (code: string) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      phone_prefix: code,
    }));
  };

  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      phone1: value,
    }));
    setFormErrors((prev) => ({
      ...prev,
      phone1: "",
    }));
  };

  const [passportSeriesOptions, setPassportSeriesOptions] = useState([
    { value: "AA", label: "AA" },
    { value: "AZE", label: "AZE" },
    { value: "MYI", label: "MYI" },
    { value: "DYI", label: "DYI" },
  ]);

  useEffect(() => {
    if (formValues.citizenship === "1") {
      setPassportSeriesOptions([
        { value: "AA", label: "AA" },
        { value: "AZE", label: "AZE" },
        { value: "AB", label: "AB" },
      ]);
    } else if (formValues.citizenship === "2") {
      setPassportSeriesOptions([
        { value: "MYI", label: "MYI" },
        { value: "DYI", label: "DYI" },
      ]);
    }

    setFormValues((prev) => ({ ...prev, passport_series: "" }));
  }, [formValues.citizenship]);

  const buildPayload = () => {
    let otp_type: "" | "sms" | "mail" = "";

    if (formValues.sms) {
      otp_type = "sms";
    } else if (formValues.mail) {
      otp_type = "mail";
    }

    dispach(setOtpType(otp_type));

    if (userStatus === "Hüquqi şəxs") {
      return {
        name: formValues.name,
        surname: formValues.surname,
        voen: formValues.voen,
        email: formValues.email,
        city: formValues.city,
        address1: formValues.address1,
        firm: formValues.firm,
        language: formValues.language,
        phone_prefix: formValues.phone_prefix || phoneCode,
        phone1: formValues.phone1,
        notSendSms: formValues.notSendSms,
        password: formValues.password,
        password_confirmation: formValues.password_confirmation,
        agreement: formValues.agreement,
        otp_type,
        ...(referralCode && { ref: referralCode }),
      };
    } else {
      return {
        name: formValues.name,
        surname: formValues.surname,
        citizenship: formValues.citizenship,
        email: formValues.email,
        city: formValues.city,
        address1: formValues.address1,
        passport_series: formValues.passport_series,
        passport_number: formValues.passport_number,
        passport_fin: formValues.passport_fin,
        language: formValues.language,
        phone_prefix: formValues.phone_prefix || phoneCode,
        phone1: formValues.phone1,
        notSendSms: formValues.notSendSms,
        birthday: formValues.birthday,
        gender: formValues.gender,
        heard_from: formValues.heard_from === "other" ? heardFromCustom : formValues.heard_from,
        password: formValues.password,
        password_confirmation: formValues.password_confirmation,
        agreement: formValues.agreement,
        otp_type,
        ...(referralCode && { ref: referralCode }),
      };
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);

    const payload = buildPayload();
    let errors: { [key: string]: string } = {};
    if (!formValues.agreement) {
      errors.agreement = `${data?.user_agreement_required}`;
    } else {
      errors.agreement = "";
    }

    if (userStatus === "Fiziki şəxs") {
      if (!formValues.heard_from) {
        errors.heard_from = "Bu xana boş ola bilməz.";
      } else if (formValues.heard_from === "other" && !heardFromCustom.trim()) {
        errors.heard_from = "Bu xana boş ola bilməz.";
      }
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors((prev) => ({
        ...prev,
        ...errors,
      }));
    }

    try {
      if (userStatus === "Fiziki şəxs") {
        await userRegisterPyhsical(payload).then((res) => {
          if (res.status === 200) {
            dispach(setIsOtp(true));
            dispach(setOtpSession(res?.data?.otp_session));
            dispach(setOperationType("register"));
            dispach(setMessageType("register"));
            clearStoredRef();
          }
        });
      } else {
        await userRegisterJuristical(payload).then((res) => {
          if (res.status === 200) {
            dispach(setIsOtp(true));
            dispach(setOtpSession(res?.data?.otp_session));
            dispach(setOperationType("register"));
            dispach(setMessageType("register"));
            clearStoredRef();
          }
        });
      }
    } catch (error: any) {
      const errorData = error?.response?.data;
      setFormErrors((prev) => ({
        ...prev,
        ...errorData?.content,
      }));
    } finally {
      setIsSubmitting(false);
    }
  };
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(!!formErrors.password || !!formErrors.password_confirmation);
  }, [formErrors]);

  return (
    <div className={styles.register}>
      <div className={styles.registerHeader}>
        <div className={styles.headerLeft} onClick={LoginClose}>
          <img className={styles.backLoginIcon} src={CloseLeft} alt="left" />
          <p className={styles.backLoginText}>Geri</p>
        </div>
        <div className={styles.headerCenter}>
          <img className={styles.logo} src={logo} alt="colibri" />
          <div>
            <p className={styles.welcomeText}>{userStatus} şəxs qeydiyyatı</p>
            <p className={styles.welcomeText}>{data?.auth_common_welcome}!</p>
          </div>
        </div>
        <Link to={"/"} onClick={LoginClose} className={styles.closeButton}>
          <img
            className={styles.closeIcon}
            src={CloseIcon}
            alt="Close Icon"
            onClick={RegisterClose}
          />
        </Link>
      </div>
      <div className={styles.registerContainer}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.inputRow}>
            <InputComponent
              label={data?.auth_referal_first_name}
              type="text"
              name="name"
              placeholder={data?.auth_referal_first_name}
              isPassword={false}
              value={formValues.name}
              onChange={handleInputChange}
              error={formErrors.name}
            />
            <InputComponent
              label={data?.auth_referal_last_name}
              type="text"
              name="surname"
              placeholder={data?.auth_referal_last_name}
              isPassword={false}
              value={formValues.surname}
              onChange={handleInputChange}
              error={formErrors.surname}
            />

            {userStatus === "Fiziki şəxs" && (
              <SelectComponent
                label={data?.auth_common_citizenship}
                name="citizenship"
                options={[
                  { value: "1", label: `${data?.azerbaijani}` },
                  { value: "2", label: `${data?.foreign_citizen}` },
                ]}
                value={formValues.citizenship}
                onChange={(value) => handleSelectChange("citizenship", value)}
                placeholder={data?.auth_attorney_select}
                error={formErrors.citizenship}
              />
            )}
            {userStatus === "Hüquqi şəxs" && (
              <InputComponent
                label={data?.auth_common_voen}
                type="text"
                name="voen"
                placeholder={data?.auth_common_voen}
                isPassword={false}
                value={formValues.voen}
                onChange={handleInputChange}
                error={formErrors.voen}
                maxLength={10}
              />
            )}

            <InputComponent
              label={data?.auth_referal_email}
              type="text"
              name="email"
              placeholder={data?.auth_referal_email}
              isPassword={false}
              value={formValues.email}
              onChange={handleInputChange}
              error={formErrors.email}
              autoComplete
            />
            <SelectComponent
              label={data?.auth_referal_city}
              name="city"
              options={cities.map((city) => ({
                value: city.id,
                label: city.title,
              }))}
              value={formValues.city}
              onChange={(value) => handleSelectChange("city", value)}
              placeholder={data?.auth_attorney_select}
              error={formErrors.city}
            />
            <InputComponent
              label={data?.auth_referal_address}
              type="text"
              name="address1"
              placeholder={data?.auth_referal_address}
              isPassword={false}
              value={formValues.address1}
              onChange={handleInputChange}
              error={formErrors.address1}
            />
            <SelectComponent
              label={data?.auth_referal_language_select}
              name="language"
              options={[
                { value: "AZ", label: "AZ" },
                { value: "EN", label: "EN" },
                { value: "RU", label: "RU" },
              ]}
              value={formValues.language}
              onChange={(value) => handleSelectChange("language", value)}
              placeholder={data?.auth_attorney_select}
              error={formErrors.language}
            />
            {userStatus === "Hüquqi şəxs" && (
              <InputComponent
                label={data?.auth_common_company}
                type="text"
                name="firm"
                placeholder={data?.auth_common_company}
                isPassword={false}
                value={formValues.firm}
                onChange={handleInputChange}
                error={formErrors.firm}
              />
            )}

            {userStatus === "Fiziki şəxs" && (
              <>
                <div className={styles.series_title} style={{ width: "60%" }}>
                  <SelectComponent
                    label={data?.auth_attorney_series_title}
                    name="passport_series"
                    options={passportSeriesOptions}
                    value={formValues.passport_series}
                    onChange={(value) =>
                      handleSelectChange("passport_series", value)
                    }
                    placeholder={data?.auth_attorney_select}
                    error={formErrors.passport_series}
                    disabled={!formValues.citizenship}
                  />
                </div>
                <InputComponent
                  label={data?.auth_attorney_series_number}
                  type="text"
                  name="passport_number"
                  placeholder="00000001"
                  isPassword={false}
                  value={formValues.passport_number}
                  onChange={handleInputChange}
                  className="pasport"
                  error={formErrors.passport_number}
                  maxLength={15}
                />
                <InputComponent
                  label={data?.auth_attorney_passport_fin}
                  type="text"
                  name="passport_fin"
                  placeholder="0000000"
                  isPassword={false}
                  value={formValues.passport_fin}
                  onChange={handleInputChange}
                  error={formErrors.passport_fin}
                  maxLength={15}
                />
              </>
            )}

            <PhoneInputComponent
              label={data?.auth_attorney_mobile}
              id="phone1"
              name="phone1"
              placeholder="0000000"
              value={""}
              onChange={handlePhoneNumberChange}
              onCodeChange={(code) => {
                handleCodeChange(code);
                setPhoneCode(code);
              }}
              error={formErrors.phone1}
              selectedCode={formValues.phone_prefix || "50"}
              combinePrefixWithNumber={false}
              maxLength={10}
            />

            {userStatus === "Fiziki şəxs" && (
              <>
                {/* <InputComponent
                  label="Doğum tarixi"
                  type="date"
                  name="birthday"
                  placeholder="__/__/____"
                  value={formValues.birthday}
                  onChange={handleInputChange}
                  error={formErrors.birthday}
                /> */}

                <div
                  className={styles.dateinputWrapper}
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className={styles.dateinputWrapper}
                    style={{ width: "100%", marginTop: "5px" }}
                  >
                    {data?.auth_referal_birth_date}
                    <div className={styles.dateInputWrapper}>
                      <InputComponent
                        label=""
                        type="date"
                        name="birthday"
                        placeholder="__/__/____"
                        value={formValues.birthday}
                        onChange={handleInputChange}
                      />
                    </div>
                    <p className={styles.errorMsg}> {formErrors.birthday}</p>
                  </div>
                </div>

                <CheckBoxSelected
                  value={formValues.gender}
                  onChange={(value) => handleSelectChange("gender", value)}
                  error={formErrors.gender}
                />

                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <SelectComponent
                    label="Bizi hardan tapdınız? *"
                    name="heard_from"
                    options={[
                      { value: "Instagram", label: "Instagram" },
                      { value: "Facebook", label: "Facebook" },
                      { value: "Google", label: "Google" },
                      { value: "other", label: "Digər" },
                    ]}
                    value={formValues.heard_from}
                    onChange={(value) => {
                      handleSelectChange("heard_from", value);
                      if (value !== "other") setHeardFromCustom("");
                    }}
                    placeholder="Seçin"
                    error={formValues.heard_from !== "other" ? formErrors.heard_from : undefined}
                  />
                  {formValues.heard_from === "other" && (
                    <InputComponent
                      label=""
                      type="text"
                      name="heard_from_custom"
                      placeholder="Necə tapdığınızı yazın..."
                      isPassword={false}
                      value={heardFromCustom}
                      onChange={(e) => {
                        setHeardFromCustom((e as React.ChangeEvent<HTMLInputElement>).target.value);
                        setFormErrors((prev) => ({ ...prev, heard_from: "" }));
                      }}
                      error={formErrors.heard_from}
                    />
                  )}
                </div>
              </>
            )}
          </div>
          <div
            className={`${styles.numberRow} ${hasError ? styles.hasError : ""}`}
          >
            <CustomCheckbox
              icon={SmsCheckboxIcon}
              text={data?.auth_common_no_sms_notify}
              color="#36654a"
              checked={formValues.notSendSms}
              onChange={(checked) =>
                setFormValues((prev) => ({
                  ...prev,
                  notSendSms: checked,
                  sms: false,
                }))
              }
            />
          </div>
          <div
            className={`${styles.passwordRow} ${
              hasError ? styles.hasError : ""
            }`}
          >
            <div className={styles.halfWidth}>
              <InputComponent
                label={data?.auth_referal_password}
                type="password"
                name="password"
                placeholder={data?.auth_referal_password}
                isPassword={true}
                isShowPassword={isShowPassword}
                toggleShowPassword={() => setIsShowPassword(!isShowPassword)}
                value={formValues.password}
                onChange={handleInputChange}
                error={formErrors.password}
                autoComplete
              />
            </div>
            <div className={styles.halfWidth}>
              <InputComponent
                label={data?.auth_referal_password_repeat}
                type="password"
                name="password_confirmation"
                placeholder={data?.auth_referal_password_repeat}
                isPassword={true}
                isShowPassword={isShowConfrimPassword}
                toggleShowPassword={() =>
                  setIsShowConfrimPassword(!isShowConfrimPassword)
                }
                value={formValues.password_confirmation}
                onChange={handleInputChange}
                error={formErrors.password_confirmation}
                autoComplete
              />
            </div>
          </div>
          <div>
            <div className={styles.CheckRow}>
              <CustomCheckbox
                icon={SmsCheckboxIcon}
                text={data?.auth_common_sms_verification}
                color="#36654a"
                checked={formValues.notSendSms ? false : formValues.sms} // Force unchecked when notSendSms is true
                onChange={(checked) => {
                  if (!formValues.notSendSms) {
                    setFormValues((prev) => ({
                      ...prev,
                      sms: checked,
                      mail: checked ? false : prev.mail,
                    }));
                    setFormErrors((prev) => ({
                      ...prev,
                      otp_type: "",
                    }));
                  }
                }}
                disabled={formValues.notSendSms}
              />
              <CustomCheckbox
                icon={SmsCheckboxIcon}
                text={data?.auth_common_email_verification}
                color="#36654a"
                checked={formValues.mail}
                onChange={(checked) => {
                  setFormValues((prev) => ({
                    ...prev,
                    mail: checked,
                    sms: checked ? false : prev.sms,
                  }));
                  setFormErrors((prev) => ({
                    ...prev,
                    otp_type: "",
                  }));
                }}
                // disabled xassəsini silirik
              />
            </div>
            <div className={styles.errorContainer}>
              {" "}
              <p className={styles.errorMsg}>{formErrors.otp_type}</p>
            </div>
          </div>

          <div className={styles.CheckRow}>
            <UserTermsCheckbox
              icon={TermsCheckboxIcon}
              text="ile raziyam"
              linkText={data?.user_agreement}
              linkHref="https://colibri.az/uploads/static/new_terms_az.pdf"
              color="#f05922"
              checked={formValues.agreement}
              onChange={(checked) =>
                setFormValues((prev) => ({ ...prev, agreement: checked }))
              }
              error={formErrors.agreement}
            />

            <MainButton
              className={styles.registerButton}
              text={data?.how_we_work_registration_title}
              type="submit"
              disabled={isSubmitting}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
export default Register;
